export default __webpack_public_path__ + "static/media/ios-fr.6cfa9afb.gif";